import {KTIcon} from '../../../../../../_metronic/helpers'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {downloadServerFile} from '../../core/_requests'
import Swal from 'sweetalert2'
import {useFilterExport} from '../../FilterProvider'
import qs from 'qs'

interface Props {
  invoiceId?: number
  franchiseId: number
}

const ListToolbar = ({invoiceId, franchiseId}: Props) => {
  const {filterExport} = useFilterExport()

  const {isLoading} = useQueryResponse()

  function isNotEmpty(obj: unknown) {
    return obj !== undefined && obj !== null && obj !== ''
  }

  // Função para limpar o objeto, removendo campos vazios, 0 ou chaves específicas
  const cleanedFilterExport = Object.keys(filterExport)
    .filter(
      (key) =>
        filterExport[key] !== '' &&
        filterExport[key] !== 0 &&
        key !== 'page' &&
        key !== 'per_page' &&
        key !== 'total'
    )
    .reduce((obj, key) => {
      obj[key] = filterExport[key]
      return obj
    }, {})

  const downloadFile = async () => {
    try {
      const result = await downloadServerFile(
        isNotEmpty(cleanedFilterExport) ? qs.stringify(cleanedFilterExport) : undefined,
        franchiseId,
        invoiceId
      )
      if (result && result.message) {
        Swal.fire({
          icon: 'info',
          title: 'Relatório em processamento',
          text: result.message,
          confirmButtonColor: '#d33',
        })
      }
    } catch (_) {}
  }

  return (
    <>
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-danger me-3'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        onClick={() => void downloadFile()}
      >
        <KTIcon iconName='exit-up' className='fs-2' />
        Export
      </button>
    </>
  )
}

export {ListToolbar}